
export const BASEURL = 'https://copaccraback.agdatagh.com/v1/';
